import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "projects/ert/src/environments/environment";
import { ERTUser } from "../../interfaces/ert-user/ert-user";
import { FormGroup } from "@angular/forms";
import { IPicklistValuesData } from "../../interfaces/administration/picklistValuesData";
const apiHost = environment.apiUrl;

@Injectable({
  providedIn: "root",
})
export class ERTUserService {
  newERTUser: ERTUser;
  constructor(private httpClient: HttpClient) {}

  public setERTUser(data: ERTUser) {
    this.newERTUser = { ...this.newERTUser, ...data };
  }

  public getAllERTUsers(facilityId: number) {
    return this.httpClient.get<ERTUser[]>(`${apiHost}/ert-users/${facilityId}`);
  }

  public getUsersAndInstructors(facilityId: number) {
    return this.httpClient.get<{ users: ERTUser[]; instructors: ERTUser[] }>(
      `${apiHost}/ert-users/getusersinstructorslist/${facilityId}`
    );
  }

  public getERTUserById(ertUserId: number, facilityId: number) {
    return this.httpClient.get<ERTUser>(
      `${apiHost}/ert-user/${ertUserId}?loggedInUserFacilityId=${facilityId}`
    );
  }

  public getUsersByCrewValueId(crewValueId: any) {
    return this.httpClient.get<ERTUser[]>(
      `${apiHost}/ert-users/bycrewvalueid/${crewValueId}`
    );
  }

  public addERTUser() {
    return this.httpClient.post(`${apiHost}/ert-users`, this.newERTUser);
  }

  public updateERTUser(ertUser: ERTUser, facilityId: number) {
    return this.httpClient.put(
      `${apiHost}/ert-users?loggedInUserFacilityId=${facilityId}`,
      ertUser
    );
  }

  public deleteERTUser(ertUserId: string, facilityId: number) {
    return this.httpClient.delete(
      `${apiHost}/ert-users/${ertUserId}?loggedInUserFacilityId=${facilityId}`
    );
  }

  public uploadFile(formData: FormData, facilityId: number) {
    return this.httpClient.post(
      `${apiHost}/ert-users/user-picture?loggedInUserFacilityId=${facilityId}`,
      formData
    );
  }

  public getUserPicture(userId: number, facilityId: number) {
    return this.httpClient.get(
      `${apiHost}/ert-users/${userId}/picture?loggedInUserFacilityId=${facilityId}`,
      {
        responseType: "blob",
      }
    );
  }

  public validateNewErtUserStep1(formGroup: FormGroup): string[] {
    const validationMessages: string[] = [];
    if (formGroup.get("division")?.value === "-1") {
      validationMessages.push("Division is required");
    }
    if (formGroup.get("unit")?.value === "-1") {
      validationMessages.push("Unit is required");
    }
    return validationMessages;
  }

  public validateNewErtUserStep2(formGroup: FormGroup): string[] {
    const validationMessages: string[] = [];
    if (!formGroup.get("firstName")?.value) {
      validationMessages.push("First Name is required");
    }
    if (!formGroup.get("lastName")?.value) {
      validationMessages.push("Last Name is required");
    }
    if (!formGroup.get("cai_email")?.value) {
      validationMessages.push("Please enter a valid email"); // CAI Deprecation
    }
    return validationMessages;
  }

  validateERTViewForm(ertViewForm: FormGroup): string[] {
    const errors: string[] = [];
    if (!ertViewForm.get("selectedFacility")?.value) {
      errors.push("Facility is required");
    }
    if (!ertViewForm.get("lastName")?.value) {
      errors.push("Last Name is required");
    }
    if (!ertViewForm.get("firstName")?.value) {
      errors.push("First Name is required");
    }
    if (!ertViewForm.get("cai_email")?.value) {
      errors.push("Please enter a valid email"); // CAI Deprecation
    }

    if (ertViewForm.get("division")?.value === "-1") {
      errors.push("Division is required");
    }
    if (ertViewForm.get("unit")?.value === "-1") {
      errors.push("Unit is required");
    }
    if (ertViewForm.get("crew")?.value === "-1") {
      errors.push("Crew is required");
    }
    if (ertViewForm.get("title")?.value === "-1") {
      errors.push("Title is required");
    }

    return errors;
  }

  public getValueForField(
    picklistValues: IPicklistValuesData[],
    fieldId: number
  ) {
    let name = "";
    if (picklistValues) {
      const fieldValue = picklistValues.find(
        (x) => x.picklistFieldId === fieldId
      );
      if (fieldValue) {
        name = fieldValue.value!.toString();
      }
    }
    return name;
  }

  getKR998ForUser(ertUserId: number) {
    return this.httpClient.get<any>(
      `${apiHost}/kr998ErtUsers/users/${ertUserId}`
    );
  }
}
